import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/grain";
import { initImageFade } from "./lib/image-fade";

initImageFade();
createRoot(document.getElementById("root")!).render(<App />);

// Register lightweight service worker for static asset caching (prod only)
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
